import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getSynch,
  getActiveToken,
  getDashboard,
  getExport,
  getVisibility,
  postMigration,
} from "./companyAPI";

const initialState = {
  data: [],
  dataDashboard: null,
  dataVisibility: null,
  dataVisibilityPerSales: [],
  dataSynch: null,
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  startDate: null,
  endDate: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "company/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchDashboard = createAsyncThunk(
  "company/fetchDashboard",
  async (payload) => {
    const response = await getDashboard(payload);
    return response;
  }
);
export const fetchVisibility = createAsyncThunk(
  "company/fetchVisibility",
  async (payload) => {
    const response = await getVisibility(payload);
    return response;
  }
);
export const fetchVisibilityPerSales = createAsyncThunk(
  "company/fetchVisibilityPerSales",
  async (payload) => {
    const response = await getVisibility(payload);
    return response;
  }
);
export const fetchDashboardNoloading = createAsyncThunk(
  "company/fetchDashboardNoloading",
  async (payload) => {
    const response = await getDashboard(payload);
    return response;
  }
);
export const fetchCompany = createAsyncThunk(
  "company/fetchCompany",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchToken = createAsyncThunk(
  "company/fetchToken",
  async (payload) => {
    const response = await getActiveToken(payload);
    return response;
  }
);

export const fetchTokenNoloading = createAsyncThunk(
  "company/fetchTokenNoloading",
  async (payload) => {
    const response = await getActiveToken(payload);
    return response;
  }
);

export const fetchSynch = createAsyncThunk("company/synch", async (payload) => {
  const response = await getSynch(payload);
  return response;
});

export const fetchId = createAsyncThunk("company/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "company/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "company/addItem",
  async ({ payload, file }) => {
    const response = await createItem(payload, file);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "company/editItem",
  async ({ payload, file }) => {
    console.log(payload, file, "slice");
    const response = await updateItem(payload, file);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "company/removeById",
  async (payload) => {
    console.log(payload, "payload");
    const response = await deleteById(payload);
    return response;
  }
);
export const fetchExport = createAsyncThunk(
  "company/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const accurateMigration = createAsyncThunk(
  "company/accurateMigration",
  async (payload) => {
    const response = await postMigration(payload);
    return response;
  }
);

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setStartDateDashboard: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDateDashboard: (state, action) => {
      state.endDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchCompany.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchSynch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSynch.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSynch = action.payload.data.data?.CUSTOM_FIELDS;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(accurateMigration.pending, (state) => {
        state.loading = true;
      })
      .addCase(accurateMigration.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchToken.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchTokenNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchTokenNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDashboard = action.payload.data.data;
      })
      .addCase(fetchVisibility.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVisibility.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVisibility = action.payload.data.data;
      })
      .addCase(fetchVisibilityPerSales.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVisibilityPerSales.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVisibilityPerSales = action.payload.data.data;
      })
      .addCase(fetchDashboardNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchDashboardNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDashboard = action.payload.data.data;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setEndDateDashboard,
  setStartDateDashboard,
} = companySlice.actions;

export const selectData = (state) => state.company.data;
export const selectDataDashboard = (state) => state.company.dataDashboard;
export const selectDataVisibility = (state) => state.company.dataVisibility;
export const selectDataVisibilityPerSales = (state) =>
  state.company.dataVisibilityPerSales;
export const selectDataCompany = (state) => state.company.data;
export const selectDataSynch = (state) => state.company.dataSynch;
export const selectId = (state) => state.company.dataId;
export const selectLoading = (state) => state.company.loading;
export const selectError = (state) => state.company.error;
export const selectPageNo = (state) => state.company.pageNo;
export const selectPageSize = (state) => state.company.pageSize;
export const selectTotalRecord = (state) => state.company.totalRecord;
export const selectSelected = (state) => state.company.selected;
export const selectStartDateDashboard = (state) => state.company.startDate;
export const selectEndDateDashboard = (state) => state.company.endDate;
export const selectResult = (state) => state.company.result;

export default companySlice.reducer;
